import React, { useEffect, useRef, useState } from 'react';
type FitScaleProps = {
  width: number;
  height: number;
  children: React.ReactNode;
  className?: string;
};

// Renders a fixed-size design canvas and scales it to the available width,
// so detailed mockups keep their exact proportions at every breakpoint.
export function FitScale({
  width,
  height,
  children,
  className = ''
}: FitScaleProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setScale(Math.min(1, el.clientWidth / width));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [width]);
  return <div ref={ref} className={`relative w-full ${className}`} style={{
    height: height * scale
  }} data-id="element-3365" data-mp="uhi3bg5qf93l">
      <div className="absolute top-0 left-0 origin-top-left" style={{
      width,
      height,
      transform: `scale(${scale})`
    }} data-id="element-3366" data-mp="6rxgunaddtpk">
        {children}
      </div>
    </div>;
}